import { render, staticRenderFns } from "./UltraTypeTreeBicavityReadOnly.vue?vue&type=template&id=06ca946e&scoped=true&"
import script from "./UltraTypeTreeBicavityReadOnly.vue?vue&type=script&lang=js&"
export * from "./UltraTypeTreeBicavityReadOnly.vue?vue&type=script&lang=js&"
import style0 from "./UltraTypeTreeBicavityReadOnly.vue?vue&type=style&index=0&id=06ca946e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ca946e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCol,VRadio,VRadioGroup,VRow,VTextarea})
